import { axios } from "../../../../constants/axiosConfig";

export async function importarDadosFromRec(cnpj) {
  return await axios
    .post(`integracao/agendar/${cnpj}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return false;
    });
}

export async function validarDadosFromRec(cnpj) {
  return await axios
    .get(`integracao/validar/${cnpj}`)
    .then((response) => {
      return response.data.Retorno;
    })
    .catch((error) => {
      return false;
    });
}